import type { Resource } from '../../';
export const general_errors_renderAlerts_timestamp: Resource = {"default":"Page Timestamp"};
